import { useTenantData } from "contexts/tenant";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useLanguage } from "./settings";
import { useCallback } from "react";

dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

export const useLocalDatetime = () => {
  const language = useLanguage();
  dayjs.locale(language);
  const { local_timezone: localTimezone } = useTenantData();
  return {
    toLocalDatetime: useCallback(
      (date: string, format: string | undefined = "L LT") =>
        dayjs(date).tz(localTimezone).format(format),
      [localTimezone]
    ),
    localTimezone,
  };
};
